import React, { Component } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    ListItemSecondaryAction
} from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DeleteIcon from '@material-ui/icons/Delete';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import { UPDATE_FEATURED_ORDER } from '../../core/handlers.actions';
import { IPost } from '../../core/models/post';
import DescriptionIcon from '@material-ui/icons/Description';


interface Props {
    posts: any;
    setNewOrder: (list:any) => void;
    wallId:string;
}
interface State {
    reorederedPosts: any | null;
}

const getItemStyle = (isDragging:any, draggableStyle:any) => ({
    // styles we need to apply on draggables
    ...draggableStyle,

    ...(isDragging && {
        background: "rgb(235,235,235)"
    })
});

const getListStyle = (isDraggingOver:any) => ({ /*background: isDraggingOver ? 'lightblue' : 'lightgrey', */});

class DnDList extends Component<Props, State> {
    state: State = { reorederedPosts: this.props.posts || null };
    constructor(props: Props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.reOrder = this.reOrder.bind(this);        
        this.removefromFeatured = this.removefromFeatured.bind(this);
    }

    public removefromFeatured(id:string){
        const { posts, setNewOrder, wallId } = this.props;
        const items = posts.filter((item: IPost) => item._id !== id).map((post:IPost, index:number) => ({id: post._id, position:index})); 
        const data = {wallId: wallId, featuredList: items}; 
        setNewOrder(data);
    }

    public reOrder(list: any, startIndex: number, endIndex: number):any {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    public async onDragEnd(result: any) {        
        const {  setNewOrder, wallId, posts} = this.props;
        if (!result.destination) return;
        const forState = await this.reOrder(posts, result.source.index, result.destination.index); 
        this.setState({...this.setState, reorederedPosts: forState});
        const items = forState.map((post:IPost, index:number) => ({id: post._id, position:index}));      
        const data = {wallId: wallId, featuredList: items};        
        setNewOrder(data);
    }

    public render() { 
        const {posts} = this.props;
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided:any, snapshot:any) => (
                        <List {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                            {posts.map((item:any, index:any) => (
                                <Draggable key={item._id} draggableId={item._id} index={index}>
                                {(provided:any, snapshot:any) => (
                                    <ListItem ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle( snapshot.isDragging, provided.draggableProps.style)}>
                                        <ListItemIcon> <DescriptionIcon />  </ListItemIcon>
                                        <ListItemText primary={item.title} secondary={`position: ${item.featuredMeta.position + 1}`}/>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => this.removefromFeatured(item._id)}><DeleteIcon color="secondary"/></IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </List>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
}
const mapDispatch = (dispatch:Dispatch) => ({
    setNewOrder: (list:any) => dispatch({type:UPDATE_FEATURED_ORDER, payload:list})
});
export default connect(null, mapDispatch)(DnDList);